module.exports = __webpack_public_path__ + "img/jxs-down-bg.0c273f63.png";